/* eslint-disable */
const ADDRESS_FIELDS = {
    ADDRESS1: 'address1',
    ADDRESS2: 'address2',
    COUNTRY: 'country',
    CITY: 'city',
    STATE_PROVINCE: 'stateProvince',
    POSTAL_CODE: 'postalCode'
};

const ADDRESS_KEYS = {
    address1: 'address1',
    address2: 'address2',
    country: 'country',
    city: 'city',
    stateProvince: 'stateProvince',
    postalCode: 'postalCode',
    //new keys to get translations
    postalCode2: 'postalCode2',
    pinCode: 'pinCode',
    province: 'province',
    cityRegency: 'cityRegency',
    districtSubdistrict: 'districtSubdistrict',

}

const keysToFields = {
    [ADDRESS_KEYS.address1]: ADDRESS_FIELDS.ADDRESS1,
    [ADDRESS_KEYS.address2]: ADDRESS_FIELDS.ADDRESS2,
    [ADDRESS_KEYS.country]: ADDRESS_FIELDS.COUNTRY,
    [ADDRESS_KEYS.city]: ADDRESS_FIELDS.CITY,
    [ADDRESS_KEYS.stateProvince]: ADDRESS_FIELDS.STATE_PROVINCE,
    [ADDRESS_KEYS.postalCode]: ADDRESS_FIELDS.POSTAL_CODE,
    //map the new keys to the address fields
    [ADDRESS_KEYS.postalCode2]: ADDRESS_FIELDS.POSTAL_CODE,
    [ADDRESS_KEYS.pinCode]: ADDRESS_FIELDS.POSTAL_CODE,
    [ADDRESS_KEYS.province]: ADDRESS_FIELDS.STATE_PROVINCE,
    [ADDRESS_KEYS.cityRegency]: ADDRESS_FIELDS.CITY,
    [ADDRESS_KEYS.districtSubdistrict]: ADDRESS_FIELDS.CITY
}

const addressFormats = {
    japanFormat: {
        countries: ['JP'],
        ignoreRTL: true,
        order: [
            [ADDRESS_KEYS.postalCode, ADDRESS_KEYS.stateProvince],
            [ADDRESS_KEYS.city],
            [ADDRESS_KEYS.address1, ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.country]
        ]
    },
    israelFormat: {
        countries: ['IL'],
        ignoreRTL: true,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.postalCode, ADDRESS_KEYS.city]
        ]
    },
    arrangement0: {
        countries: ['BR'],
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.postalCode2],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.city],
            [ADDRESS_KEYS.stateProvince]
        ]
    },
    arrangement1: {
        countries: ['MX'],
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.postalCode2],
            [ADDRESS_KEYS.city],
            [ADDRESS_KEYS.stateProvince]
        ]
    },
    arrangement2: {
        countries: ['ID'],
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.cityRegency],
            [ADDRESS_KEYS.province, ADDRESS_KEYS.postalCode2]
        ]
    },
    arrangement3: {
        countries: ['TH', 'VN'],
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.districtSubdistrict],
            [ADDRESS_KEYS.province, ADDRESS_KEYS.postalCode2]
        ]
    },
    arrangement4: {
        countries: ['IN'],
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.city],
            [ADDRESS_KEYS.stateProvince, ADDRESS_KEYS.pinCode]
        ]
    },
    default: {
        ignoreRTL: false,
        order: [
            [ADDRESS_KEYS.country],
            [ADDRESS_KEYS.address1],
            [ADDRESS_KEYS.address2],
            [ADDRESS_KEYS.city],
            [ADDRESS_KEYS.stateProvince, ADDRESS_KEYS.postalCode]
        ]
    }
};

export {
    addressFormats,
    keysToFields,
    ADDRESS_FIELDS
};
